//Metadata

export interface TypeCollapse {
    code: number;
    name: string;
}

export interface RouteInfo {
    code: number;
    path: string;
    title: string;
    type: string;
    type_collapsable: TypeCollapse;
    icontype: string;    
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    code?: number;
    path: string;
    title: string;
    icon: string;
    type?: string;
}

export const TYPE_COLLAPSABLE: TypeCollapse[] = [
    {code: 1, name: 'all'},
    {code: 2, name: 'subitem'},
];

export const ROUTES: RouteInfo[] = [];

// export const ROUTES: RouteInfo[] = [{
//     path: '/dashboard',
//     title: 'Dashboard',
//     type: 'link',
//     icontype: 'dashboard'
// },
// {
//     path: '/components',
//     title: 'Components',
//     type: 'sub',
//     icontype: 'apps',
//     collapse: 'components',
//     children: [
//         {path: 'buttons', title: 'Buttons', ab:'B'},
//         {path: 'grid', title: 'Grid System', ab:'GS'},
//         {path: 'panels', title: 'Panels', ab:'P'},
//         {path: 'sweet-alert', title: 'Sweet Alert', ab:'SA'},
//         {path: 'notifications', title: 'Notifications', ab:'N'},
//         {path: 'icons', title: 'Icons', ab:'I'},
//         {path: 'typography', title: 'Typography', ab:'T'}
//     ]
// },
// {
//     path: '/forms',
//     title: 'Forms',
//     type: 'sub',
//     icontype: 'content_paste',
//     collapse: 'forms',
//     children: [
//         {path: 'regular', title: 'Regular Forms', ab:'RF'},
//         {path: 'extended', title: 'Extended Forms', ab:'EF'},
//         {path: 'validation', title: 'Validation Forms', ab:'VF'},
//         {path: 'wizard', title: 'Wizard', ab:'W'}
//     ]
// },
// {
//     path: '/tables',
//     title: 'Tables',
//     type: 'sub',
//     icontype: 'grid_on',
//     collapse: 'tables',
//     children: [
//         {path: 'regular', title: 'Regular Tables', ab:'RT'},
//         {path: 'extended', title: 'Extended Tables', ab:'ET'},
//         {path: 'datatables.net', title: 'Datatables.net', ab:'DT'}
//     ]
// },
// {
//     path: '/maps',
//     title: 'Maps',
//     type: 'sub',
//     icontype: 'place',
//     collapse: 'maps',
//     children: [
//         {path: 'google', title: 'Google Maps', ab:'GM'},
//         {path: 'fullscreen', title: 'Full Screen Map', ab:'FSM'},
//         {path: 'vector', title: 'Vector Map', ab:'VM'}
//     ]
// },
// {
//     path: '/widgets',
//     title: 'Widgets',
//     type: 'link',
//     icontype: 'widgets'

// },
// {
//     path: '/charts',
//     title: 'Charts',
//     type: 'link',
//     icontype: 'timeline'

// },{
//     path: '/calendar',
//     title: 'Calendar',
//     type: 'link',
//     icontype: 'date_range'
// },{
//     path: '/pages',
//     title: 'Pages',
//     type: 'sub',
//     icontype: 'image',
//     collapse: 'pages',
//     children: [
//         {path: 'pricing', title: 'Pricing', ab:'P'},
//         {path: 'timeline', title: 'Timeline Page', ab:'TP'},
//         {path: 'login', title: 'Login Page', ab:'LP'},
//         {path: 'register', title: 'Register Page', ab:'RP'},
//         {path: 'lock', title: 'Lock Screen Page', ab:'LSP'},
//         {path: 'user', title: 'User Page', ab:'UP'}
//     ]
// }
// ];